import { RequestService } from '../../../../common/services/RequestService';
import { GET_EMPLOYEES } from '../constants';
import { dataAdjustmentResponse } from './dataAdjustment';

export const getEmployeesRequest = async currentProfileId => {
  const response = await RequestService.get(GET_EMPLOYEES + currentProfileId);
  return response.data.map(emploee => dataAdjustmentResponse(emploee));
};
